import { graphql } from 'react-relay';

/**
 * Microsoft
 */

export * from './__generated__/Integration_MicrosoftInfo_Query.graphql';
export const MsInfoQuery = graphql`
  query Integration_MicrosoftInfo_Query {
    msInfo {
      isAuthenticated
    }
  }
`;

/**
 * Hubspot
 */

export * from './__generated__/Integration_HubspotInfo_Query.graphql';
export const HsInfoQuery = graphql`
  query Integration_HubspotInfo_Query {
    hsInfo {
      isValidToken
      owners {
        id
        email
        first_name
        last_name
      }
      defaultOwner {
        id
        email
        first_name
        last_name
      }
      allowedContactProperties {
        key
        value
      }
      contactProperties {
        key
        value
      }
      scopes
    }
  }
`;

/**
 * Zoho
 */

export * from './__generated__/Integration_ZohoInfo_Query.graphql';
export const ZohoInfoQuery = graphql`
  query Integration_ZohoInfo_Query($salesIqPortalId: String) {
    zohoInfo {
      hasAuth
      salesIqPortals {
        id
        name
        logo
        screenName
        createdTime
      }
      salesIqApps(portalId: $salesIqPortalId) {
        id
        name
        code
      }
      salesIqPortalId
      salesIqAppId
      salesIqAppCode
    }
  }
`;

/**
 * Marketo
 */

const MarketoInfoFragment = graphql`
  fragment Integration_MarketoInfo_Fragment on MarketoSettings {
    marketoApiActive
    munchkinId
    clientId
    clientSecret
    hasClientSecret
    formsEnabled
    staticListIds 
  }
`;

export * from './__generated__/Integration_MarketoInfo_Query.graphql';
export const MarketoInfoQuery = graphql`
  query Integration_MarketoInfo_Query {
    marketoInfo {
      settings {
      ...Integration_MarketoInfo_Fragment @relay(mask: false)
      }
    }
  }
`;

export * from './__generated__/Integration_Manager_Query.graphql';
export const IntegrationsManagerQuery = graphql`
  query Integration_Manager_Query {
    integrationsManager {
      activeIntegrations
    }
  }
`;
